import { Badge, Box, Breadcrumbs, Button, ButtonGroup, Checkbox, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Modal, Select, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import React, { useEffect } from "react";
import { MdNavigateNext } from "react-icons/md";
import { Link, useParams } from "react-router-dom";
import { get, isEmpty } from "lodash";
import { setEditQuestion, stateValues, stateRefresh } from '../../slices/categorySlice';
import moment from "moment";
import { ACTIVE_ALL_PREDICTION_SALE, CHECK_TOTAL_TRADES_TRADING, MOVE_TO_FINISH_TRADE, TRADING_CANCEL, TRADING_CHANGE_STATUS, TRADING_DISTRIBUTE_WINNING, TRADING_FORCE_CANCEL, TRADING_LIST, TRADING_WINNING_SET } from "../../constant/endpoint";
import Swal from "sweetalert2";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { AiFillCloseCircle } from 'react-icons/ai';
import Skelton from "../../common/Skelton";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useStyles } from "../../constant/constant";
import ModalForRate from "../../common/modal";
import FormComponent from "../../components/BotForm";
import { getTradeYesAndNo, setTradeRate, showTradeRate } from "../../helper";
import jwt_decode from "jwt-decode";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: '75%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    padding: '0px 30px',
    overflow: "auto",
    paddingBottom: "20px"
};

export const CategoryDetails = () => {
    const { match_id } = useParams()
    const user = useSelector(state => state.loginSlice)
    const [activeSaleAll, setActiveSaleAll] = React.useState(1);
    const userProfile = !isEmpty(user?.token) ?  jwt_decode(user?.token) : {accessLevel: 0}
    const series_id = 11111
    const [open, setOpen] = React.useState(false);
    const [trading, setTrading] = React.useState([]);
    const [imageofQustion, setImageofQustion] = React.useState(undefined);
    const [value, setValue] = React.useState('1');
    const [tradeCount, setTradeCount] = React.useState({});
    const [sort, setSort] = React.useState({});
    const [Loading, setLoading] = React.useState(true);
    const [invisible, setInvisible] = React.useState(false);
    const classes = useStyles();
    const [rateModal, setRateModal] = React.useState(false)
    const [rateData, setRateData] = React.useState({})
    const [showBotModal, setShowBotModal] = React.useState({})

    const handleBadgeVisibility = () => {
        setInvisible(!invisible);
    };
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const imageFile = (e) => {
        const file = e.target.files[0]
        setImageofQustion(file)
    }
    const handleOpen = () => {
        dispatch(stateRefresh())
        setOpen(true)
        setImageofQustion('')
        dispatch(stateValues({ name: 'predic_start_time', value: `${moment().format("YYYY-MM-DD")}T${moment().format("HH:mm")}` }))
    };
    const handleClose = () => setOpen(false);
    const dispatch = useDispatch();
    const categorySlice = useSelector(state => state.categorySlice)
    useEffect(() => {
        if (isEmpty(trading) && Loading) {
            getOpinionTrading()
        }
    })

    const getOpinionTrading = async () => {
        setLoading(true)
        const response = await axios.get(TRADING_LIST.replace(':match_id', match_id).replace(':series_id', series_id).replace(":sport", 1))
        setActiveSaleAll( (response?.data?.data && response?.data?.data?.active_all_sale ) || 0 )
        if (response?.data?.status && !isEmpty(response.data.data)) {
            setTrading(response.data.data.result)
        }
        setLoading(false)
    }


    const setQuestion = (e) => {
        dispatch(stateValues({ name: e.target.name, value: e.target.value }))
    }

    const selectCorrectAnswer = (e) => {
        const option = categorySlice.questionStates.option.map(data => data.id === Number(e.target.value) ? { ...data, isCorrect: true } : { ...data, isCorrect: false })
        dispatch(stateValues({ name: 'option', value: option }))
    }
    const editOptions = (event, id) => {
        const option = categorySlice.questionStates.option.map(data => data.id === Number(id) ? { ...data, option: event.target.value } : { ...data })
        dispatch(stateValues({ name: 'option', value: option }))
    }

    // Alert Function
    const getSweetAlert = (type, topic) => {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: topic,
            showConfirmButton: false,
            timer: 3000
        })
    }

    const submit = async () => {
        if (IsValidation()) {
            await submitQuestion()
        }
    }

    const submitQuestion = async () => {
        const formData = new FormData()
        let data = {
            ...categorySlice.questionStates,
            match_id,
            series_id,
            predic_start_time: moment(categorySlice.questionStates.predic_start_time).utc().format(),
            predic_end_time: moment(categorySlice.questionStates.predic_end_time).utc().format(),
            category_type: true
        }
        if(activeSaleAll && !categorySlice.questionStates.isEdit){
            data["sale_full_amount"] = activeSaleAll   
        }
        formData.append('image', imageofQustion);
        formData.append('data', JSON.stringify(data));
        delete data.status
        let result;
        if (categorySlice.questionStates.isEdit) {
            result = await axios.patch(TRADING_LIST.replace(':match_id', match_id).replace(':series_id', series_id), formData)
        } else {
            result = await axios.post(TRADING_LIST.replace(':match_id', match_id).replace(':series_id', series_id), formData)

        }

        if (result?.data?.status === 'success') {
            if (!categorySlice.isEdit) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Added',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Edit',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        getOpinionTrading()
        handleClose()
    }
    const IsValidation = () => {

        let status = true
        const data = categorySlice.questionStates
        if (isEmpty(data.question_english)) {
            status = false
            getSweetAlert('error', 'Enter the question')
        } else if (data.slots_per_user <= 0) {
            status = false
            getSweetAlert('error', 'Enter Slot Per user')
        }
        else if (isEmpty(data.predic_start_time)) {
            status = false
            getSweetAlert('error', 'Start Time Must Be More Than Present Time')

        } else if (isEmpty(data.predic_end_time) || (moment(data.predic_end_time).format("YYYY-MM-DD, HH:mm") < moment(data.predic_start_time).format("YYYY-MM-DD, HH:mm"))) {
            status = false
            getSweetAlert('error', 'End Time Must be Larger Than Start Time')
        } else if (+data.slots_per_user > 100000) {
            status = false
            getSweetAlert('error', 'Slot not more than 10000')
        } else if (Number(data.admin_commission) < 10) {
            status = false
            getSweetAlert('error', 'Admin Commission Not Less Than 10')
        }
        else if (data?.option.find((op) => (op.option === ""))) {
            status = false
            getSweetAlert('error', 'Please Enter Options')
        }
        return status
    }
    const editQuestion = (data, noOpen) => {
        setImageofQustion('')
        setOpen(true)
        const inPlayData = {
            ...data,
            predic_start_time: `${moment(data.predic_start_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_start_time).format("HH:mm")}`,
            predic_end_time: `${moment(data.predic_end_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_end_time).format("HH:mm")}`,
            isEdit: true,
        };
        dispatch(setEditQuestion(inPlayData));
        getOpinionTrading()
    }
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={'/category'} >
            <h4>Category</h4>
        </Link>, <Link
            underline="hover"
            color="inherit"
        >
            Category Questions
        </Link>
    ];
    const questionStatus = async (status, _id) => {
        let data;
        if (status) {
            data = { status: 0, match_id, series_id, _id, sport: 1 }
        } else {
            data = { status: 1, match_id, series_id, _id, sport: 1 }
        }
        await axios.post(TRADING_CHANGE_STATUS, data)
        getOpinionTrading()
    }
    const tradingCancel = async (data, _id) => {
        const answer = data.option.filter(x => x.isCorrect)[0].option
        let optionObj = {
            "Select answer": "Select answer"
        };
        for (var obj of data.option) {
            optionObj[obj.option] = obj.option
        }
        Swal.fire({
            title: 'Confirm Your Answer',
            input: 'select',
            inputOptions: optionObj,
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Cancel The Match',
            showLoaderOnConfirm: true,

            preConfirm: async (item) => {
                console.log(item);
                if (item !== answer) {
                    getSweetAlert('error', 'Please Correct Answer')
                } else {
                    await axios.post(TRADING_CANCEL.replace(':match_id', match_id).replace(':series_id', series_id).replace(':prediction_id', _id))
                    getOpinionTrading()
                }
            }
        })
    }
    const setWinning = async (data) => {
        const resultCheck = await Swal.fire({
            title: `Do you want Winning Set?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are setting the winning',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const optionAnser = data.option
            const isCorrectId = (optionAnser.find(data => data.isCorrect)).id
            const bodyData = {
                correct_id: isCorrectId,
                admin_commision: data.admin_commission,
                sport: data.sport
            }
            const result = await axios.post(

                // /winning_set/trading/match/${match_id}/series/series_id/trade/:trade_id
                TRADING_WINNING_SET.replace(':match_id', match_id).replace(':series_id', series_id).replace(':id', data._id), bodyData
            );
            if (result?.data?.status === "success") {
                getOpinionTrading()
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Winning set successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        }
    };
    const winningDistribution = async (id) => {
        if (!activeSaleAll) {
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Please Active Sale Button",
                showConfirmButton: false,
                timer: 1500,
            });
                return;
        }
        const resultCheck = await Swal.fire({
            title: `Do you want Winning Distribute?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are distributing the winning',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const result = await axios.post(
                TRADING_DISTRIBUTE_WINNING.replace(':match_id', match_id).replace(':prediction_id', id)
            );
            if (result?.data?.status === 'success') {
                getOpinionTrading()
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Winning Distribution successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        }
    };
    const forceCancelPrediction = async (prediction_id) => {
        const result = await Swal.fire({
            title: 'Do you want to cancel the prediction ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (result.isConfirmed) {
            const result = await axios.post(
                TRADING_FORCE_CANCEL.replace(':prediction_id', prediction_id)
            );
            if (result?.data?.status === 'success') {
                getOpinionTrading()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Prediction Cancel successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        }
    }

    const handleShorting = async (data) => {
        let data1 = {
            ...data
        }
        data1.sort_number = sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number
        delete data1.status
        const formData = new FormData()
        formData.append('image', imageofQustion);
        formData.append('data', JSON.stringify(data1));

        let result = await axios.patch(TRADING_LIST.replace(':match_id', match_id).replace(':series_id', series_id), formData)

        if (result?.data?.status === 'success') {
            if (!categorySlice.questionStates.isEdit) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Sorting add Successfully',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Sort Add Successfully',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        getOpinionTrading()
    }
    const handleSortingInput = (e, id) => {
        if (e.target.value) {
            setSort(prevValue => ({ ...prevValue, [id]: { sort_number: e.target.value } }))
        }
    }
    const checkTotolTrades = async (match_id, sport, id) => {
        const response = await axios.get(CHECK_TOTAL_TRADES_TRADING.replace(':match_id', match_id).replace(':sport', sport).replace(':id', id))
        if (response?.data?.status === 'success') {
            setTradeCount({ data: response.data.data, id: id })
            // if(response.data.data == null){
            //     setTradeCount({data:0})
            // }else{
            // }
        }
    }
    const setRate = (data) => {
        setRateModal(true)
        setRateData(data)
    }

    const setBotSlot = (data) => {
        Swal.fire({
            title: 'Provide The Passwords',
            input: 'password',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            showLoaderOnConfirm: true,
            preConfirm: (text) => {
                if (text === 'showForm') {
                    const newData = {
                        _id: data._id,
                        join_rate: data.join_rate,
                        exit_rate: data.exit_rate,
                        join_option_id: data.join_option_id,
                        number_of_slots: data.number_of_slots,
                        join_percentage: data.join_percentage,
                        match_id: data.match_id,
                        series_id: data.series_id,
                    }
                    setShowBotModal(newData)
                }
            }
        })
    }

    const hideBotModal = () => {
        setShowBotModal({})
        getOpinionTrading()
    }

    const moveToFinish = async (id) => {
        const isValid = await Swal.fire({
            title: 'Do you want to Finish the Prediction',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (isValid.isConfirmed) {
            const result = await axios.post(`${MOVE_TO_FINISH_TRADE.replace(':trade_id', id).replace(':match_id', match_id).replace(':series_id', series_id)}`)
            if (result.data.status === "success") {
                Swal.fire({
                    title: 'Success',
                    text: result.data.data,
                    position: 'center'
                })
            }
            getOpinionTrading()
        }
    }

    const activeSaleForAllQuestion = async () => {
        const resultCheck = await Swal.fire({
            title: `Do you want to change Status?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are Active Sale for all questions ',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const result = await axios.post(ACTIVE_ALL_PREDICTION_SALE.replace(':match_id', match_id).replace(':sport', 1))
            if (result.data.status === "success") {
                Swal.close()
                Swal.fire({
                    title: 'Success',
                    text: result.data.data,
                    position: 'top-end',
                    timer: 1500,
                    showConfirmButton: false
                })
                getOpinionTrading()
            }
        }
    }
    return (
        <>
            {!isEmpty(showBotModal) ? <FormComponent data={showBotModal} hideBotModal={hideBotModal} /> : ''}
            <div className="homeCard">
                <div className='subHomeCard'>
                    <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >

                        {breadcrumbs}
                    </Breadcrumbs>
                    <Grid container style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "20px", borderBottom: "1px solid #ccc" }}>
                                <Grid item>
                                    <Grid container style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "20px", }}>
                                        <Grid item spacing={3}>
                                            <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                                                <Button variant={'contained'} disabled={activeSaleAll ? true : false} color='error' style={{ color: activeSaleAll ? "#000" : "#fff", marginRight: "10px" }} onClick={activeSaleForAllQuestion}>Sale {activeSaleAll ?  "ACTIVE" : "INACTIVE"}</Button>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                    <Button variant={'contained'} color={'primary'} style={{ float: "right" }} onClick={() => handleOpen()}>Add Questions</Button>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleChange} aria-label="lab API tabs example">
                                    <Tab label="LIVE" value="1" />
                                    <Tab label="RESULT" value="2" />
                                </TabList>
                            </Box>
                            <TabPanel style={{ padding: "0px" }} value="1">
                                <TableContainer style={{ margin: "30px 0px" }}>
                                    <Table className={classes.table} sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Id</TableCell>
                                                <TableCell align="left">Image</TableCell>
                                                <TableCell align="left">Question</TableCell>
                                                <TableCell align="center">End Time</TableCell>
                                                <TableCell align="center">Sorting</TableCell>
                                                <TableCell align="center">Answer</TableCell>
                                                <TableCell align="center">Rate</TableCell>
                                                <TableCell align="center">Edit</TableCell>
                                                {/* <TableCell align="center">Slots Join</TableCell> */}
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Cancel</TableCell>
                                                <TableCell align="center">Set</TableCell>
                                                {userProfile.accessLevel >= 100 && <TableCell align="center">Check</TableCell>}
                                                <TableCell align="center">Finish</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {trading.filter((data) => !(data.is_finish) && !(data.is_processing)).length > 0 ? trading.filter((data) => !(data.is_finish) && !(data.is_processing))?.map((data, index) => (
                                                <TableRow
                                                    key={data.name}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {index + 1}
                                                    </TableCell>
                                                    <TableCell><img style={{ width: "40px" }} src={data.image} alt='' /></TableCell>
                                                    <TableCell style={{ width: "300px" }}>{data.question_english}</TableCell>
                                                    <TableCell align="center">{moment(data.predic_end_time).format("HH:mm")} {moment(data.predic_end_time).format("YYYY-MM-DD")}</TableCell>

                                                    <TableCell align="left" style={{ display: "flex", background: '#ecffe2', width: "60px" }}>
                                                        <Grid container style={{ display: "flex", background: '#fff' }}>
                                                            <TextField type='number' width={'50px'} size='small' id="outlined-basic" label="Sorting" variant="outlined" style={{ fontStyle: "8px" }} onChange={(e) => handleSortingInput(e, data._id)} autocomplete="off" value={sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number} />
                                                            <Button variant='contained' color={'warning'} style={{ fontSize: "11px", width: "60px", padding: '1px' }} onClick={() => handleShorting(data)}>Update</Button>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        <p>{data?.option?.filter(x => x.isCorrect)[0]?.option}</p>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        <Button variant={'contained'} size={'small'} color={'secondary'} onClick={() => showTradeRate(data.match_id, data._id)}>Get</Button>
                                                        <Button variant={'contained'} sx={{mt: 1}} size={'small'} color={'secondary'} onClick={() => setTradeRate(data._id, data.match_id, data.interval)}>Set</Button>
                                                    </TableCell>
                                                    <TableCell align='center'><Button variant={'contained'} size={'small'} color={'warning'} onClick={() => editQuestion(data)}>Edit</Button></TableCell>
                                                    {/* <TableCell align='center'><Button variant={'contained'} size={'small'} color={'info'} onClick={() => setBotSlot(data)}>Set</Button></TableCell> */}
                                                    <TableCell align='center'>

                                                        <Button variant={'contained'} size={'small'} color={data.status ? 'success' : 'error'} onClick={() => questionStatus(data.status, data._id)}>{data.status ? 'Active' : 'InActive'}</Button>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        {
                                                            Number(data.status) === 0 && data?.option.some(x => x.isCorrect) &&
                                                            <Button variant={'contained'} size={'small'} color={'error'} onClick={() => tradingCancel(data, data._id)} >Cancel</Button>
                                                        }
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        {
                                                            data.is_slot_cancel === 1 ? <Button variant={'contained'} size={'small'} color={'success'} onClick={() => setWinning(data)}>Set</Button> : ''
                                                        }
                                                        {
                                                            data.is_pred_winset === 1 ? <Button style={{ margin: "5px 10px" }} variant={'contained'} size={'small'} color={'success'} onClick={() => winningDistribution(data._id)}>Distribute</Button> : ''
                                                        }
                                                    </TableCell>
                                                    {userProfile.accessLevel >= 100 &&  <TableCell><Button variant={'contained'} size={'small'} color='info' onClick={() => getTradeYesAndNo(data._id)}>Check</Button></TableCell>}
                                                    <TableCell>
                                                            {data.status !== 1 && data.is_pred_winset !== 1 && userProfile?.accessLevel
                                                            > 90 ? <Button variant={'contained'} size={'small'} color={'secondary'} onClick={() => moveToFinish(data._id)}>Finish</Button> : ''}
                                                    </TableCell>
                                                </TableRow>
                                            )) : Loading ? <Skelton /> : <TableRow><TableCell colSpan={12} style={{ textAlign: "center", padding: "10px" }}><h3>Data Not Found</h3></TableCell></TableRow>}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </TabPanel>
                            <TabPanel style={{ padding: "0px" }} value="2">
                                <TableContainer style={{ margin: "30px 0px" }}>
                                    <Table className={classes.table} sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Id</TableCell>
                                                <TableCell align="left">Question</TableCell>
                                                <TableCell align="center">End Time</TableCell>
                                                <TableCell align="center">Rate_id 1</TableCell>
                                                <TableCell align="center">Rate_id 2</TableCell>
                                                <TableCell align="center">View</TableCell>
                                                <TableCell align="center">View Total Trades</TableCell>
                                                <TableCell align="center">Cancel</TableCell>
                                                <TableCell align="center">Set Rate</TableCell>
                                                <TableCell align="center">Set</TableCell>
                                                {/* <TableCell align="center">Force Cancel</TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {trading.filter((data) => data.is_finish).length > 0 ? trading.filter((data) => data.is_finish)?.map((data, index) => (
                                                <TableRow
                                                    key={data.name}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {index + 1}
                                                    </TableCell>
                                                    <TableCell>{data.question_english}</TableCell>
                                                    <TableCell align="center">{moment(data.predic_end_time).format("HH:mm")} {moment(data.predic_end_time).format("YYYY-MM-DD")}</TableCell>
                                                    <TableCell align='center'>
                                                        {data.rate_id01}
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        {data.rate_id02}
                                                    </TableCell>
                                                    <TableCell align='center'><Button variant={'contained'} size={'small'} color={'warning'} onClick={() => editQuestion(data)} >View</Button></TableCell>
                                                    <TableCell align='center'>
                                                        {
                                                            data._id === tradeCount?.id ? <h3>{tradeCount?.data}</h3> : ''
                                                        }
                                                        <Button variant={'contained'} size={'small'} color={'success'} style={{ fontSize: "11px", width: "60px", padding: '1px' }} onClick={() => checkTotolTrades(data.match_id, data.sport, data._id)}>Check</Button>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        <Button variant={'contained'} size={'small'} color={'secondary'} onClick={() => setRate(data)}>Set Rate</Button>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        <Button variant={'contained'} size={'small'} color={'error'} onClick={() => tradingCancel(data._id)} disabled >Cancel</Button>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        {
                                                            data.is_slot_cancel === 1 ? <Button variant={'contained'} size={'small'} color={'success'} onClick={() => setWinning(data)} disabled>Set</Button> : ''
                                                        }
                                                        {
                                                            data.is_pred_winset === 1 ? <Button style={{ margin: "5px 10px" }} variant={'contained'} size={'small'} color={'success'} onClick={() => winningDistribution(data._id)} disabled>Distribute</Button> : ''
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                            )) : Loading ? <Skelton /> : <TableRow><TableCell colSpan={12} style={{ textAlign: "center", padding: "10px" }}><h3>Data Not Found</h3></TableCell></TableRow>}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </TabPanel>
                        </TabContext>
                    </Box>
                </div>
                <Modal
                    open={open}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    onBackdropClick={() => setOpen(true)}
                >
                    <Box sx={style} spacing={0.5} direction="row" useFlexGap flexWrap="wrap">
                        <Grid container>
                            <Grid xs={11}>
                                <h2 id="modal-title" mb={1}>{'Category'}  Questions</h2>
                            </Grid>
                            <Grid xs={1}>
                                <Button onClick={handleClose}><AiFillCloseCircle style={{ width: "25px", height: "40px" }} /></Button>
                            </Grid>
                            <h4> {categorySlice.questionStates._id && 'Pred id-'}  {categorySlice?.questionStates?._id}</h4>
                        </Grid>
                        <hr />
                        <Grid container spacing={1}>
                            <Grid xs={4} item>
                                <label>Slots Per User</label>
                                <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'slots_per_user'} onChange={setQuestion} value={categorySlice.questionStates.slots_per_user} disabled={categorySlice.isEdit === true ? true : false} />
                            </Grid>
                            <Grid xs={6} item>
                                <label>Admin Per Commission</label>
                                <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'admin_commission'} onChange={setQuestion} value={categorySlice.questionStates.admin_commission} disabled={categorySlice.isEdit === true ? true : false} />
                            </Grid>
                            <Grid container ml={1} mt={1}>
                                <Grid xs={6} item>
                                    <label>Start Date and Time</label>
                                    <TextField type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_start_time'} value={categorySlice.questionStates.predic_start_time} onChange={setQuestion} disabled={categorySlice.isEdit === true ? true : false} />
                                </Grid>
                                <Grid xs={6} item>
                                    <label>End Date and Time</label>
                                    <TextField type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_end_time'} value={categorySlice.questionStates.predic_end_time} onChange={setQuestion} disabled={get(categorySlice, "questionStates.is_finish")} />
                                </Grid>
                            </Grid>
                            <Grid xs={12} item mt={1}>
                                <label>Interval</label>
                                <br></br>
                                <>
                                    <ButtonGroup style={{ marginTop: "20px" }}>
                                        <Button
                                            aria-label="reduce"
                                            onClick={() => {
                                                dispatch(stateValues({ name: 'interval', value: Math.max(+categorySlice.questionStates.interval - 0.5, 0.5) }))
                                            }}
                                        >
                                            <strong>-</strong>
                                        </Button>
                                        <Badge color="secondary" badgeContent={categorySlice.questionStates.interval}>
                                        </Badge>
                                        <Button
                                            style={{ marginRight: "30px" }}
                                            aria-label="increase"
                                            onClick={() => {
                                                dispatch(stateValues({ name: 'interval', value: Math.min(+categorySlice.questionStates.interval + 0.5, 1) }))
                                            }}
                                        >
                                            <strong>+</strong>
                                        </Button>
                                    </ButtonGroup>
                                    <FormControlLabel control={<Checkbox onChange={(e) => dispatch(stateValues({ name: 'is_global_trade', value: !categorySlice?.questionStates?.is_global_trade }))} name={'is_global_trade'} defaultChecked={categorySlice?.questionStates?.is_global_trade} value={categorySlice?.questionStates?.is_global_trade} />} label="Global Trade" />
                                </>
                            </Grid>
                            <Grid xs={12} item mt={1}>
                                <label>Write Question in English</label>
                                <TextField fullWidth id="standard-basic" size={'small'} placeholder="Write Question in English" name={'question_english'} value={categorySlice.questionStates.question_english} variant="outlined" onChange={setQuestion} disabled={get(categorySlice, "questionStates.is_finish") || get(categorySlice, "questionStates.status") === 1} />
                            </Grid>
                            <Grid xs={12} item mt={1}>
                                <label>Write Question in Hindi</label>
                                <TextField fullWidth id="standard-basic" size={'small'} placeholder="Write Question in Hindi" name={'question_hindi'} value={categorySlice.questionStates.question_hindi} variant="outlined" onChange={setQuestion} disabled={get(categorySlice, "questionStates.is_finish") || get(categorySlice, "questionStates.status") === 1} />
                            </Grid>

                            <Grid xs={12} mt={1} item>
                                <label>Options</label>
                                {categorySlice?.questionStates?.option?.length ? categorySlice?.questionStates?.option.map((data) => (
                                    <TextField style={{ marginBottom: '10px' }} fullWidth value={data?.option} size={'small'} disabled={get(categorySlice, "questionStates.is_finish") || get(categorySlice, "questionStates.status") === 1} onChange={(event) => editOptions(event, data.id)}></TextField>
                                )) : ""}
                            </Grid>
                            {
                                <>
                                    {
                                        categorySlice.questionStates.isEdit &&
                                        <Grid item container>
                                            <FormControl variant="outlined" size={'small'} sx={{ m: 1, minWidth: '100%' }}>
                                                {!isEmpty(categorySlice.questionStates.option) &&
                                                    <>
                                                        <InputLabel id="demo-simple-select-label">Please Select Answer</InputLabel>
                                                        <Select id="demo-simple-select-label" style={{ margin: '10px' }} type='select' value={get(get(categorySlice, 'questionStates.option', []).find(data => data.isCorrect), 'id', '')} disabled={get(categorySlice, "questionStates.status") || categorySlice.questionStates.is_slot_cancel === 1 || categorySlice.questionStates.is_finish ? true : false} onChange={selectCorrectAnswer}>
                                                            {get(categorySlice, 'questionStates.option', []).map((data, index) =>
                                                                <MenuItem value={data.id} key={index}>{data?.option}</MenuItem>
                                                            )}
                                                        </Select>
                                                    </>
                                                }
                                            </FormControl>
                                        </Grid>
                                    }
                                    <Grid xs={12}>
                                        <input
                                            accept="image/*"
                                            id="contained-button-file"
                                            multiple
                                            type="file"
                                            onChange={imageFile}
                                        />
                                    </Grid>
                                    <Grid xs={9} mt={2}>
                                        <Button color='error' onClick={handleClose} variant="contained">Cancel</Button>
                                    </Grid>
                                    <Grid xs={3} mt={2} textAlign={'right'}>
                                        <Button onClick={submit} variant="contained">Submit</Button>
                                    </Grid>
                                </>
                            }
                        </Grid>
                    </Box>
                </Modal>
                {
                    rateModal && <ModalForRate rateModal={setRateModal} data={rateData} />
                }
            </div>
        </>
    )
}